import { useCallback, useEffect, useMemo, useState } from 'react';

export interface UseRatingReturn {
  rating: number;
  hoverRating: number;
  displayRating: number;
  setRating: (rating: number) => void;
  setHoverRating: (rating: number) => void;
  handleRate: (rating: number, onRate?: (rating: number) => void) => void;
  handleHover: (rating: number) => void;
  handleMouseLeave: () => void;
  handlers: {
    handleRate: (rating: number, onRate?: (rating: number) => void) => void;
    handleHover: (rating: number) => void;
    handleMouseLeave: () => void;
  };
}

export const useRating = (initialRating = 0): UseRatingReturn => {
  const [rating, setRating] = useState<number>(initialRating);
  const [hoverRating, setHoverRating] = useState<number>(0);

  useEffect(() => {
    setRating(initialRating);
  }, [initialRating]);

  const handleRate = useCallback((nextRating: number, onRate?: (rating: number) => void) => {
    setRating(nextRating);
    onRate?.(nextRating);
  }, []);

  const handleHover = useCallback((nextHoverRating: number) => {
    setHoverRating(nextHoverRating);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoverRating(0);
  }, []);

  const displayRating = useMemo(() => hoverRating || rating, [hoverRating, rating]);

  return {
    rating,
    hoverRating,
    displayRating,
    setRating,
    setHoverRating,
    handleRate,
    handleHover,
    handleMouseLeave,
    handlers: {
      handleRate,
      handleHover,
      handleMouseLeave
    }
  };
};
